import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiBell, FiClock, FiCheck, FiZap } = FiIcons;

const PaymentAutomationSettings = ({ onSave }) => {
  const [settings, setSettings] = useState({
    autoReminders: true,
    reminderDaysBefore: 3,
    followUpDaysAfter: 2,
    lateFeePercentage: 5,
    gracePeriodDays: 3
  });

  return (
    <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-xl animate-in slide-in-from-right duration-300">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-indigo-100 text-indigo-600 rounded-2xl">
          <SafeIcon icon={FiSettings} size={24} />
        </div>
        <div>
          <h3 className="text-xl font-black text-gray-900">Automation Logic</h3>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Global Payment Rules</p>
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl">
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiBell} className="text-indigo-500" />
            <div>
              <p className="text-sm font-black text-gray-900">Enable Smart Reminders</p>
              <p className="text-[10px] text-gray-400 font-bold">Auto-send alerts via Email/SMS</p>
            </div>
          </div>
          <button 
            onClick={() => setSettings({...settings, autoReminders: !settings.autoReminders})}
            className={`w-12 h-6 rounded-full transition-colors relative ${settings.autoReminders ? 'bg-indigo-600' : 'bg-gray-300'}`}
          >
            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${settings.autoReminders ? 'left-7' : 'left-1'}`} />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-1">
              <SafeIcon icon={FiClock} size={10} /> First Nudge
            </label>
            <div className="flex items-center gap-2">
              <input 
                type="number" 
                value={settings.reminderDaysBefore}
                onChange={(e) => setSettings({...settings, reminderDaysBefore: e.target.value})}
                className="w-full p-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-black outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <span className="text-[10px] font-bold text-gray-400 uppercase">Days Before</span>
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-1">
              <SafeIcon icon={FiZap} size={10} /> Escalation
            </label>
            <div className="flex items-center gap-2">
              <input 
                type="number" 
                value={settings.followUpDaysAfter}
                onChange={(e) => setSettings({...settings, followUpDaysAfter: e.target.value})}
                className="w-full p-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-black outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <span className="text-[10px] font-bold text-gray-400 uppercase">Days After</span>
            </div>
          </div>
        </div>

        <div className="p-4 bg-amber-50 rounded-2xl border border-amber-100">
          <p className="text-[10px] text-amber-700 font-black uppercase mb-1">Grace Period Enforcement</p>
          <p className="text-xs text-amber-600 font-medium leading-relaxed">
            Late fees will be automatically calculated after {settings.gracePeriodDays} days of delinquency.
          </p>
        </div>

        <button 
          onClick={() => onSave(settings)}
          className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-indigo-700 transition shadow-lg shadow-indigo-100 flex items-center justify-center gap-2"
        >
          <SafeIcon icon={FiCheck} /> Sync Automation
        </button>
      </div>
    </div>
  );
};

export default PaymentAutomationSettings;